import { createIcon } from './create-icon'

export const Low = createIcon({
  displayName: 'Low',
  paths: [
    'M768.414 639.817c-8.107 0-16.213-2.129-23.467-7.245l-232.533-154.752-232.533 154.752c-19.627 13.214-46.080 7.671-59.307-11.938s-7.68-46.042 11.947-59.255l256-170.525c14.507-9.379 32.853-9.379 47.36 0l256 170.525c19.627 13.214 24.747 39.646 11.947 59.255-8.107 12.365-21.76 19.183-35.413 19.183z'
  ]
})
